<template>
  <div>
    <el-form label-position="top" :rules="rules" ref="ruleForm" label-width="80px" :model="rulesForm">
      <vue-dividing-line title="基本設定"></vue-dividing-line>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="題目編號" prop="question_no">
            <el-input v-model="rulesForm.question_no" placeholder="請輸入題目編號"></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="語言" prop="lang">
            <el-select v-model="rulesForm.lang" placeholder="請選擇語言">
              <el-option v-for="(item, index) in lang" :key="index"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item label="分數" prop="score"> 
            <el-input-number v-model="rulesForm.score" controls-position="right" :min="1" placeholder="請輸入分數"></el-input-number>
          </el-form-item
        ></el-col>
        <!-- <el-col :span="12">
          <el-form-item label="難易程度">
            <el-select v-model="rulesForm.level" placeholder="請選擇難度">
              <el-option v-for="(item, idx) in level" :key="idx"
                :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item
        ></el-col> -->
      </el-row>
      <vue-dividing-line title="問題及插圖"></vue-dividing-line>
      <el-form-item label="問題" prop="title">
        <Tinymce v-model="rulesForm.title" ref="Tinymce"></Tinymce>
      </el-form-item>
      <el-form-item label="問題圖片">
        <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="onUploadSuccess"></upload>
        <div class="img-box" v-if="rulesForm.img_url">
          <div class="close" @click="rulesForm.img_url = ''"></div>
          <img :src="rulesForm.img_url" />
        </div>
      </el-form-item>
      <vue-dividing-line title="選項及答案"></vue-dividing-line>
      <div v-for="(item, index) in choice_option" :key="index">
        <div class="required">選項{{ letter[index] }} </div>
        <el-row type="flex">
          <el-col :span="3" >顯示方式 </el-col>
          <el-col
            >
              <el-radio-group v-model="item.type">
                <el-radio label="text">文字</el-radio>
                <el-radio label="image">圖片</el-radio>
              </el-radio-group>
            </el-col
          >
          <!-- <div class="remove-choice" @click="removeChoice(index)" v-if="choice_option.length > 2">移除选项</div> -->
        </el-row>
        <el-form-item label="文字" v-if="item.type == 'text'">
          <el-input v-model="item.text"  placeholder="請輸入文字"></el-input>
          <div v-if="!item.text && rules_switch" class="prop-tips">請輸入文字</div>
        </el-form-item>
        <el-form-item label="圖片" v-else>
          <upload :placeholder="rulesForm.img_url || '請選擇問題圖片'" @childByValue="url => onUploadSuccessChoice(url, item)"></upload>
          <div class="img-box" v-if="item.image">
            <div class="close" @click="item.image = ''"></div>
            <img :src="item.image" />
          </div>
          <div v-else-if="rules_switch" class="prop-tips">請選擇圖片</div>
        </el-form-item>
      </div>
      <!-- <div class="newly-added" @click="addChoice" v-if="choice_option.length < 5">新增选项</div> -->
      <div class="required">正確答案 </div>
      <el-form-item label="選項">
        <el-checkbox v-model="item.answer" v-for="(item, index) in choice_option" :key="index" @change="changeCheckbox"
         v-show="(item.type == 'text' && item.text.trim() != '') || (item.type == 'image' && item.image != '')">
          選項{{ letter[index] }}
        </el-checkbox>
        <div class="prop-tips" v-if="isAnswer && rules_switch">請選擇正確答案</div>
      </el-form-item>
      <vue-dividing-line title="解答思路"></vue-dividing-line>
      <Tinymce v-model="rulesForm.explanation"></Tinymce>
      <div class="sibmit-button">
        <div class="left">
          <el-button type="info" @click="onSubmit">提交</el-button>
          <el-button type="success" @click="onBack">取消</el-button>
        </div>
        <el-button type="info" @click="preview">預覽題目</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import upload from "@/components/upload";
import Tinymce from "@/components/Tinymce";
import { symbol } from '../plugins/directive'
import rules from "../plugins/validator";

export default {
  directives: {
    symbol
  },
  props: ['formLabelAlign'],
  components: { upload, Tinymce },

  data() {
    let letter = new Array(26).fill().map((its, idx) => its = String.fromCharCode(65 + idx))
    return {
      letter, 

      // 语言
      lang: [
        {label: '中文', value: 0},
        {label: '英文', value: 1},
      ],
      // 难易程度
      level: [
        {label: '※', value: 1},
        {label: '※※', value: 2},
        {label: '※※※', value: 3},
        {label: '※※※※', value: 4},
        {label: '※※※※※', value: 5},
      ],
      rulesForm: {},
      // rulesForm: {
      //   lang: "",
      //   title: "",
      //   img_url: '',
      //   type: 0,
      //   score: 1,
      //   level: 1,
      //   explanation: '',
      //   answers: [],
      //   choices: [],
      //   content: '',
      // },
      rules,
      units: [],
      choice_option: [
        {type: 'text', image: '', text: '', answer: false, letter: 'A'},
        {type: 'text', image: '', text: '', answer: false, letter: 'B'},
        {type: 'text', image: '', text: '', answer: false, letter: 'C'},
        {type: 'text', image: '', text: '', answer: false, letter: 'D'},
        {type: 'text', image: '', text: '', answer: false, letter: 'E'},
      ],
      rules_switch: false,
    };
  },
  computed: {
    isAnswer: function() {
      return !this.choice_option.some(its => its.answer)
    }
  },
  methods: {
    preview() {
      let form = this.handleFromData()
      form.type = 0
      this.$emit('preview', form)
    },
    isShow(row) {
      if(row.type == 'text') 
        if(row.text.trim() != '') return true
        else return false
      else if(row.type == 'image') 
        if(row.mage != '') return true
        else return false
    },
    changeCheckbox() {
      // console.log(this.choice_option)
    },
    removeChoice(idx) {
      this.choice_option.splice(idx, 1);
    },
    addChoice() {
      let {letter, choice_option} = this
      this.choice_option.push({type: 'text', image: '', text: '', answer: false, letter: letter[choice_option.length]})
    },
    childByVideoUrl(v) {
      this.rulesForm.videoUrl = v;
      this.$forceUpdate();
    },
    onUploadSuccess(url) {
      this.rulesForm.img_url = url;
    },
    onUploadSuccessChoice(url, item) {
      item.image = url
    },
    validator_data() {
      let { choice_option } = this,
      is_exist = choice_option.filter(its => {
        if(its.type == 'text' && its.text.trim() != '') return its
        if(its.type == 'image' && its.image != '') return its
        return false
      })

      this.$refs['ruleForm'].validate(() => {})
      if(is_exist.length < 2) {
        this.$message.error('最少填寫倆項')
        return true
      }
      return false
    },
    handleFromData() {
      let form = JSON.parse(JSON.stringify(this.rulesForm)),
      { choice_option } = this

      // 处理數据
      form.answers = []
      form.choices = []
      choice_option.filter((item, idx) => {
        let type = item.type == 'text' ? 0 : 1,
        value = item.type == 'text' ? `${item.letter}.${item.text}` : `${item.letter}.${item.image}`
        form.choices.push({ type, value})

        if(item.answer && (item.text.trim() != '' || item.image != '')) form.answers.push({value: idx})
      })

      if(form.answers.length == 0) {
        this.$message.error('正確答案最少勾選壹項')
        return
      }

      form.content = JSON.stringify({
        choice_option
      })
      console.log(form, choice_option)
      return form
    },
    // 提交
    onSubmit() {
      if(this.validator_data()) return ;

      let form = this.handleFromData()

      // type, type_display
      this.$emit('save', form, 0, 0)
    },
    // 返回
    onBack() {
      this.$emit('cancel', this.rulesForm)
    },

    // 处理編輯數据
    handleEditData() {
      let {content} = this.rulesForm,
      {choice_option} = JSON.parse(content)
      // console.log(choice_option)

      this.choice_option = choice_option
    }
  },
  created() {
    this.rulesForm = {...this.formLabelAlign}
  },
  mounted() {
    // console.log(this.rulesForm)
    if(this.rulesForm.id) {
      this.handleEditData()
    }
  }
};
</script>

<style lang="scss" scoped>
.newly-added, .remove-choice {
  display: block;
  width: 120px;
  padding: 10px 0;
  text-align: center;
  font-size: 20px;
  color: #333;
  background-color: #ffb842;
  border-radius: 10px;
  cursor: pointer;
  margin-bottom: 10px;
}
.remove-choice {
  background-color: #EA4C4E;
  color: #fff;
}
</style>